module.exports = {
  "defaultCurrency": "EUR",
  "currencies": [
    {
      "id": 1,
      "code": "EUR",
      "name": "€EUR",
      "change_store": false,
      "store": null,
      "base_currency": null
    }
  ]
}